<template>
    <v-container fluid fill-height >
        <div class="search-bar">
            <v-layout align-center justify-center row>
                <div>
                    <h3>{{ this.$t('message.paymentStatusTitle') }}</h3>
                </div>
            </v-layout>
            <v-layout align-center justify-center row>
                <v-flex xs12 md6 >
                    <div class="text-xs-center" style="margin: 20px; font-size: 16px"> {{ this.$t('message.paymentStatusHelpText') }} </div>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row>
                <v-flex xs12 sm3>
                    <v-btn solo color="primary" href="https://www.epagos.whirlpool.com.mx/">{{ this.$t('message.paymentStatusButtonText') }}</v-btn>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<style scoped>
    .search-bar {
        margin-top: 20%;
    }
</style>


<script>
  export default {
  }
</script>